module.exports = __webpack_public_path__ + "img/blue-lagoon.af1c234f.jpg";